export const FETCH_FAMILY_MEMBERS_REQUEST = "FETCH_FAMILY_MEMBERS_REQUEST";
export const FETCH_FAMILY_MEMBERS_SUCCESS = "FETCH_FAMILY_MEMBERS_SUCCESS";
export const FETCH_FAMILY_MEMBERS_FAILURE = "FETCH_FAMILY_MEMBERS_FAILURE";

export const ADD_FAMILY_MEMBER_REQUEST = "ADD_FAMILY_MEMBER_REQUEST";
export const ADD_FAMILY_MEMBER_SUCCESS = "ADD_FAMILY_MEMBER_SUCCESS";
export const ADD_FAMILY_MEMBER_FAILURE = "ADD_FAMILY_MEMBER_FAILURE";

export const UPDATE_FAMILY_MEMBER_REQUEST = "UPDATE_FAMILY_MEMBER_REQUEST";
export const UPDATE_FAMILY_MEMBER_SUCCESS = "UPDATE_FAMILY_MEMBER_SUCCESS";
export const UPDATE_FAMILY_MEMBER_FAILURE = "UPDATE_FAMILY_MEMBER_FAILURE";

export const DELETE_FAMILY_MEMBER_REQUEST = "DELETE_FAMILY_MEMBER_REQUEST";
export const DELETE_FAMILY_MEMBER_SUCCESS = "DELETE_FAMILY_MEMBER_SUCCESS";
export const DELETE_FAMILY_MEMBER_FAILURE = "DELETE_FAMILY_MEMBER_FAILURE";

export const FETCH_FAMILY_MEMBER_REQUEST = "FETCH_FAMILY_MEMBER_REQUEST";
export const FETCH_FAMILY_MEMBER_SUCCESS = "FETCH_FAMILY_MEMBER_SUCCESS";
export const FETCH_FAMILY_MEMBER_FAILURE = "FETCH_FAMILY_MEMBER_FAILURE";

export const RESET_FAMILY_MEMBER = "RESET_FAMILY_MEMBER";
